// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Moment from "moment";
import * as Caml_option from "../../../../../rescript/lib/es6/caml_option.js";

var Duration = {};

function add(duration, moment) {
  var clone = moment.clone();
  clone.add(duration);
  return clone;
}

function subtract(duration, moment) {
  var clone = moment.clone();
  clone.subtract(duration);
  return clone;
}

function startOf(timeUnit, moment) {
  var clone = moment.clone();
  clone.startOf(timeUnit);
  return clone;
}

function endOf(timeUnit, moment) {
  var clone = moment.clone();
  clone.endOf(timeUnit);
  return clone;
}

function setMillisecond(millisecond, moment) {
  var clone = moment.clone();
  clone.millisecond(millisecond);
  return clone;
}

function setSecond(second, moment) {
  var clone = moment.clone();
  clone.second(second);
  return clone;
}

function setMinute(minute, moment) {
  var clone = moment.clone();
  clone.minute(minute);
  return clone;
}

function setHour(hour, moment) {
  var clone = moment.clone();
  clone.hour(hour);
  return clone;
}

function setDate(date, moment) {
  var clone = moment.clone();
  clone.date(date);
  return clone;
}

function setDay(day, moment) {
  var clone = moment.clone();
  clone.day(day);
  return clone;
}

function setWeekday(weekday, moment) {
  var clone = moment.clone();
  clone.weekday(weekday);
  return clone;
}

function setIsoWeekday(isoWeekday, moment) {
  var clone = moment.clone();
  clone.isoWeekday(isoWeekday);
  return clone;
}

function setDayOfYear(dayOfYear, moment) {
  var clone = moment.clone();
  clone.dayOfYear(dayOfYear);
  return clone;
}

function setWeek(week, moment) {
  var clone = moment.clone();
  clone.week(week);
  return clone;
}

function setIsoWeek(isoWeek, moment) {
  var clone = moment.clone();
  clone.isoWeek(isoWeek);
  return clone;
}

function setQuarter(quarter, moment) {
  var clone = moment.clone();
  clone.quarter(quarter);
  return clone;
}

function setWeekYear(weekYear, moment) {
  var clone = moment.clone();
  clone.weekYear(weekYear);
  return clone;
}

function setIsoWeekYear(isoWeekYear, moment) {
  var clone = moment.clone();
  clone.weekYear(isoWeekYear);
  return clone;
}

function setMonth(month, moment) {
  var clone = moment.clone();
  clone.month(month);
  return clone;
}

function setYear(year, moment) {
  var clone = moment.clone();
  clone.year(year);
  return clone;
}

function toJSON(moment) {
  return Caml_option.null_to_opt(moment.toJSON());
}

var Moment$1 = {
  add: add,
  subtract: subtract,
  startOf: startOf,
  endOf: endOf,
  setMillisecond: setMillisecond,
  setSecond: setSecond,
  setMinute: setMinute,
  setHour: setHour,
  setDate: setDate,
  setDay: setDay,
  setWeekday: setWeekday,
  setIsoWeekday: setIsoWeekday,
  setDayOfYear: setDayOfYear,
  setWeek: setWeek,
  setIsoWeek: setIsoWeek,
  setQuarter: setQuarter,
  setWeekYear: setWeekYear,
  setIsoWeekYear: setIsoWeekYear,
  setMonth: setMonth,
  setYear: setYear,
  toJSON: toJSON
};

function momentWithUnix(timestamp) {
  return Moment(timestamp * 1000.0);
}

function momentUtc(format, value) {
  if (format !== undefined) {
    return Moment.utc(value, format);
  } else {
    return Moment.utc(value);
  }
}

function moment(format, value) {
  if (format !== undefined) {
    return Moment(value, format);
  } else {
    return Moment(value);
  }
}

export {
  Duration ,
  Moment$1 as Moment,
  momentWithUnix ,
  momentUtc ,
  moment ,
  
}
/* moment Not a pure module */
